import {typeExport} from "../../../../../redux/store/type";

const reducerPaySatiaScreen = (state = { NoInternetDialog: false, results: null ,  isLoading:false, }, action) => {
    switch (action.type) {
        case typeExport.PaySatiaScreen_SERVICE_PENDING:
            return {
                ...state,
                NoInternetDialog: false,
                isLoading:true ,
                results:null
            };
        case typeExport.PaySatiaScreen_SERVICE_ERROR:
            return {
                ...state,
                NoInternetDialog: true,
                isLoading:false ,
                error: action.error
            };
        case typeExport.PaySatiaScreen_SERVICE_SUCCESS:
            return {
                ...state,
                results: action.results,
                NoInternetDialog: false ,
                isLoading:false ,

            };

            case typeExport.PaySatiaScreen_SERVICE_REFRESH:
                return {
                    ...state,
                results: action.results,
                NoInternetDialog: false ,
                isLoading:false ,
            };

        default:
            return state;
    }
}

export default reducerPaySatiaScreen;
